import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCompliance } from '../../contexts/ComplianceContext';
import LoadingSpinner from 'components/common/LoadingSpinner';

const ComplianceGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isCompliance, loading } = useCompliance();

  if (loading) return (
    <LoadingSpinner />
  )
  if (!isCompliance) return <Navigate to="/compliance/login" replace />;
  return <>{children}</>;
};

export default ComplianceGuard;
